<template>
  <a-modal
    :title="modalTitTxt"
    :visible="isLimitDialogShow"
    :footer="null"
    width="627px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @cancel="isLimitDialogShow=false"
  >
    <div class="invoice-info-box">
      <div class="search-box">
        <a-input
          v-model="val"
          type="text"
          :placeholder="headTit"
          class="ant-input"
          @change="searchItem"
        />
        <i
          class="icon iconfont iconicon-test45"
          @click="searchItem"
        />
      </div>
      <div class="list-tab">
        <a-table
          :columns="columns"
          :pagination="false"
          :data-source="invoiceHistoryListData"
          class="table-list"
        >
          <div
            slot="type"
            slot-scope="type, record"
            class="order-cell"
          >
            <span v-if="record.type===2">{{ $t('message["1562"]') }}</span>
            <span v-else>{{ $t('message["1563"]') }}</span>
          </div>
          <div
            slot="invoicetitle"
            slot-scope="invoicetitle, record"
            class="order-cell"
          >
            <span>{{ record.invoicetitle }}</span>
          </div>
          <div
            slot="title_type"
            slot-scope="title_type, record"
            class="order-cell"
          >
            <div class="op-tool-box">
              <a
                href="javascript:;"
                @click="importItem(record)"
              >{{ $t('message["190"]') }}</a>
            </div>
          </div>
        </a-table>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    titletype: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isLimitDialogShow: false,
      val: '',
      currentPage: 1,
      confirmLoading: false
    }
  },
  computed: {
    ...mapGetters('account/invoice', ['invoiceHistoryListData']),
    ...mapState('account/invoice', ['invoiceHistoryDatas']),
    len () {
      if (this.invoiceHistoryDatas.length) {
        return this.invoiceHistoryDatas.length
      }
      return 0
    },
    modalTitTxt () {
      return this.$t('message["272"]')
    },
    headTit () {
      return this.$t('message["1160"]')
    },
    columns () {
      const columns = [ {
        title: this.$t('message["270"]'),
        key: 'type',
        dadaIndex: 'type',
        scopedSlots: { customRender: 'type' }
      }, {
        title: this.$t('message["1160"]'),
        key: 'invoicetitle',
        dadaIndex: 'invoicetitle',
        scopedSlots: { customRender: 'invoicetitle' }
      },
      {
        title: this.$t('message["79"]'),
        key: 'title_type',
        dadaIndex: 'title_type',
        scopedSlots: { customRender: 'title_type' }
      }
      ]
      return columns
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('account/invoice', ['fetchInvoiceHistoryDatas']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    async searchItem () {
      // let item = {}
      // this.editDiaListData.forEach(ele => {
      //   if (ele.truename === this.val || (ele.mobile === this.val)) {
      //     item = ele
      //     return false
      //   }
      // })
      // this.checkList.push(item.userid)
      const chain = await this.fetchInvoiceHistoryDatas()
      chain.params({
        titletype: this.titletype,
        type: this.type,
        title: this.val
      })
        .fetch()
    },
    importItem (item) {
      this.$emit('importData', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-box {
  position: relative;
  width: 320px;
  margin-bottom: 24px;

  .icon {
    font-size: 14px;
    color: #ccc;
    position: absolute;
    right: 10px;
    top: 9px;
  }
}

.page-box {
  padding: 16px 0;
  text-align: right;
}
</style>
